<template>
  <div :class="bemBlock">
    <span
      :class="[
        bemElement('text'),
        {
          'visually-hidden': isBreakpointMobile,
        },
      ]"
      >{{ $msg('productList.columns.legend', 'productList') }}</span
    >
    <template v-for="value in columnModes">
      <button
        :key="`plp-column-mode-button-${value}`"
        :class="[
          bemElement('mode', {
            selected: isColumnModeSelected(value),
          }),
          'u-btn-clean',
          'interaction--enabled-hover-v1',
        ]"
        :aria-label="getColumnModeName(value)"
        @click="handleColumnModeClick(value)"
      >
        <template v-if="isBreakpointMobile">
          <i
            :class="[
              `icon-cols-${getNumColumns(value)}`,
              {
                'is-selected': isColumnModeSelected(value),
              },
            ]"
          /><span class="visually-hidden">{{ getNumColumns(value) }}</span>
        </template>
        <template v-else>
          {{ getNumColumns(value) }}
        </template>
      </button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';
import getAnalyticsEventBus from '../../common/getAnalyticsEventBus';
import getFrontConfig from '../../common/getFrontConfig';
import windowResizeMixin from '../mixins/windowResizeMixin';
import EventBusConfig from '../config/eventBusConfig';

const analyticsEventBus = getAnalyticsEventBus();
const FRONT_CONFIG = getFrontConfig();
const columnModeDefault = FRONT_CONFIG.vue.TheProductList.columnMode.default;
const columnModeCompressed =
  FRONT_CONFIG.vue.TheProductList.columnMode.compressed;

export default {
  name: 'TheProductListColumnMode',

  mixins: [bemClassesMixin, windowResizeMixin],

  data() {
    return {
      columnModes: [columnModeDefault, columnModeCompressed],
      dataChangeBreakpoint: FRONT_CONFIG.responsive.bp_768,
    };
  },

  computed: {
    ...mapState({
      columnMode: (state) => state.productList.ui.columnMode,
    }),

    columnModeData() {
      let res;
      if (this.isBreakpointMobile) {
        res = {
          [columnModeDefault]: {
            cols: 2,
            text: this.$msg('productList.columns.two', 'productList'),
          },
          [columnModeCompressed]: {
            cols: 4,
            text: this.$msg('productList.columns.four', 'productList'),
          },
        };
      } else {
        res = {
          [columnModeDefault]: {
            cols: 4,
            text: this.$msg('productList.columns.four', 'productList'),
          },
          [columnModeCompressed]: {
            cols: 8,
            text: this.$msg('productList.columns.eight', 'productList'),
          },
        };
      }
      return res;
    },
  },

  methods: {
    /**
     * Get the name of a column mode according to the device
     * @param {string} columnMode - column mode
     * @return {string} column mode name
     */
    getColumnModeName(columnMode) {
      return this.columnModeData[columnMode].text;
    },
    /**
     * Get the number of columns of a mode according to the device
     * @param {string} columnMode - column mode
     * @return {number} number of columns
     */
    getNumColumns(columnMode) {
      return this.columnModeData[columnMode].cols;
    },
    /**
     * Handle column mode click
     * @param {string} columnMode - column mode just selected
     */
    handleColumnModeClick(columnMode) {
      if (this.columnMode !== columnMode) {
        this.$eventBus.$emit(
          EventBusConfig.events.TheProductList.columnModeWillChange
        );
        this.$store.commit(types.productList.setColumnMode, columnMode);
        this.$eventBus.$emit(
          EventBusConfig.events.TheProductList.columnModeChanged
        );
      }
      // Send event for analytics
      analyticsEventBus.publish(
        analyticsEventBus.EVENTS.productListColumnModeClicked,
        this.columnMode
      );
    },
    /**
     * Check whether a column mode is selected
     * @param {string} columnMode - column mode
     */
    isColumnModeSelected(columnMode) {
      return columnMode === this.columnMode;
    },
  },
};
</script>
